
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DDOVTOIH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DDOVTOIH.vue